// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Z9EM","footer":"ReportModalFilter_footer__2O06Y"};